export default "__VITE_ASSET__83qGxjdF__"